window.__tnt || (window.__tnt = {});

(function(document, __tnt) {
    var me = __tnt.slider || (__tnt.slider = {}),
        pagination = {};
        
        me.pagination = {
            init: function() {
                me.pagination.constructSlider(document.querySelector('.asset-content .tnt-paginated-article-template'));
            },
            constructSlider: function(el) {
                var container = document.createElement('div'),
                outerStage = document.createElement('div'),
                innerStage = document.createElement('div');
                
                container.classList.add('tnt-paginated-article');
                outerStage.classList.add('tnt-paginated-article-outer-stage');
                innerStage.classList.add('tnt-paginated-article-stage');
                
                __tnt.template(
                    el,
                    innerStage,
                    false,
                    [],
                    function(t) {
                        t.firstChild.classList.add('active');
                    }
                );
                
                outerStage.appendChild(innerStage);
                container.appendChild(outerStage);
                el.parentElement.appendChild(container);
                
                this.setStage(container);
                this.createNavigation(container);
                this.createListener(container);
                
                utilities.loaded(container);
            },
            setStage: function(el) {
                utilities.stageSize(el);
                utilities.setTranslate(el, 1);
            },
            createNavigation: function(el) {
                var total = el.querySelector('.tnt-paginated-article-stage').children.length;
                var topNav = document.createElement('div');
                topNav.classList.add('tnt-paginated-article-controls');
                topNav.classList.add('hidden-print');
                
                var prevBtn = utilities.navElement(true);
                var nextBtn = utilities.navElement(false);
                        
                var counter = document.createElement('div');
                counter.classList.add('tnt-paginated-article-controls-counter');
                var indexEl = document.createElement('span');
                indexEl.classList.add('tnt-paginated-index');
                indexEl.textContent = '1';
                var totalEl = document.createElement('span');
                totalEl.classList.add('tnt-paginated-total');
                totalEl.textContent = total;
                
                counter.append('Page ');
                counter.appendChild(indexEl);
                counter.append(' of ');
                counter.appendChild(totalEl);
                
                topNav.appendChild(prevBtn);
                topNav.appendChild(counter);
                topNav.appendChild(nextBtn);
                
                var bottomNav = topNav.cloneNode(true);
                
                el.prepend(topNav);
                el.appendChild(bottomNav);
            },
            previousSlide: function(el) {
                var activePage = el.querySelector('.active'),
                iPos = activePage.previousElementSibling.dataset.item;
            
                utilities.beforeSlide(el, 'prev');
                activePage.previousElementSibling.classList.add('active');
                utilities.setTranslate(el, iPos);
            
                setTimeout(function() {
                    activePage.classList.remove('active');
                    utilities.afterSlide(el, function() {
                        utilities.returnToTop(el, function() {
                            utilities.autoHeight(el);
                        });
                    });
                }, 100);
            },
            nextSlide: function(el) {
                var activePage = el.querySelector('.active'),
                iPos = activePage.nextElementSibling.dataset.item;
            
                utilities.beforeSlide(el, 'next');
                activePage.nextElementSibling.classList.add('active');
                utilities.setTranslate(el, iPos);
            
                setTimeout(function() {
                    activePage.classList.remove('active');
                    utilities.afterSlide(el, function() {
                        utilities.returnToTop(el, function() {
                            utilities.autoHeight(el);
                        });
                    });
                }, 100);
            },
            createListener: function(el) {
                var stage = el.querySelector('.tnt-paginated-article-stage'),
                btnsNext = el.querySelectorAll('.tnt-slider-next button'),
                btnsPrev = el.querySelectorAll('.tnt-slider-previous button'),
                i;
            
                for (i = 0; i < btnsPrev.length; ++i) {
                    btnsPrev[i].addEventListener('click', function() {
                        me.pagination.previousSlide(el);
                    });
                }
            
                for (i = 0; i < btnsNext.length; ++i) {
                    btnsNext[i].addEventListener('click', function() {
                        me.pagination.nextSlide(el);
                    });
                }
            
                window.addEventListener('load', function() {
                    utilities.autoHeight(el);
                });
                
                var resizeTimer;
            
                window.addEventListener('resize', function() {
                    el.querySelector('.tnt-paginated-article-stage').classList.add('resizing');
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(function() {
                        var activePage = parseInt(utilities.currentPosition(el));
                        utilities.stageSize(el);
                        utilities.setTranslate(el, activePage);
                        utilities.autoHeight(el, activePage);
                        el.querySelector('.tnt-paginated-article-stage').classList.remove('resizing');
                    }, 250);
                });
            
            }
    };
    var utilities = {
        loaded: function(el) {
            this.elementToggle(el);
        },
        beforeSlide: function(el, dir) {
            this.adController(el, dir);
        },
        afterSlide: function(el, callback) {
            this.elementToggle(el);
            this.slideCounter(el);
            this.trackEvent(el);
            if (callback) callback();    
        },
        trackEvent: function(el) {
            var object = JSON.parse(el.querySelector('.active').getAttribute('data-track-object'));
            __tnt.trackEvent(object);
        },
        adController: function(el, dir) {
            var stage = el.querySelector('.tnt-paginated-article-stage'),
            topAd = el.querySelector('.tnt-paginated-article-ad-one'),
            middleAd = el.querySelector('.tnt-paginated-article-ad-two'),
            bottomAd = el.querySelector('.tnt-paginated-article-ad-three'),
            optPoint = el.querySelector('.tnt-paginated-article-middle-opt-in'),
            activePage;
        
            if (dir == 'prev') {
                activePage = el.querySelector('.active').previousElementSibling;
            } else {
                activePage = el.querySelector('.active').nextElementSibling;
            }
        
            var activePageChildren = activePage.children.length,
            activePageMiddleChild = Math.round(activePage.children.length/2),
            offset = activePage.children
        
            topAd.parentElement.removeChild(topAd);
            activePage.children[0].insertAdjacentElement('afterend', topAd);
            
            optPoint.parentElement.removeChild(optPoint);
            activePage.children[activePageMiddleChild].insertAdjacentElement('afterend', optPoint);
            
            middleAd.parentElement.removeChild(middleAd);
            activePage.children[activePageMiddleChild].insertAdjacentElement('afterend', middleAd);
            
            bottomAd.parentElement.removeChild(bottomAd);
            activePage.children[activePageChildren + 1].insertAdjacentElement('afterend', bottomAd);
                
            if (typeof TNCMS.AdManager != 'undefined' && TNCMS.AdManager != null) {
                TNCMS.AdManager.refresh();
            }
        },
        elementToggle: function(el) {
            var currentIndex = parseInt(this.currentPosition(el)),
            stage = el.querySelector('.tnt-paginated-article-stage'),
            btnsNext = el.querySelectorAll('.tnt-slider-next button'),
            btnsPrev = el.querySelectorAll('.tnt-slider-previous button');
        
            for (var i = 0; i < btnsPrev.length; ++i) {
                if (currentIndex == 1) {
                    btnsPrev[i].classList.add('hide');
                } else {
                    btnsPrev[i].classList.remove('hide');
                }
            }
        
            for (var i = 0; i < btnsNext.length; ++i) {
                if (currentIndex == stage.children.length) {
                    btnsNext[i].classList.add('hide');
                } else {
                    btnsNext[i].classList.remove('hide');
                }
            }
        
            if (document.querySelector('.paging-link')) {
                if (currentIndex == 1) {
                    document.querySelector('.paging-link.prev').classList.remove('offset');
                } else {
                    document.querySelector('.paging-link.prev').classList.add('offset');
                }
            
                if (currentIndex == stage.children.length) {
                    document.querySelector('.paging-link.next').classList.remove('offset'); 
                } else {
                    document.querySelector('.paging-link.next').classList.add('offset'); 
                }
            }
        },
        currentPosition: function(el) {
            var activePagePos = el.querySelector('.active').dataset.item;
            return activePagePos;
        },
        navElement: function(prev) {
            prev = (prev === true || prev === false) ? prev : true;
            var df = document.createDocumentFragment();
            var div = document.createElement('div');
            if (prev) {
                div.classList.add('tnt-slider-previous');
            } else {
                div.classList.add('tnt-slider-next');
            }
            var btn = document.createElement('button');
            btn.classList.add('btn');
            btn.classList.add('btn-default');
            btn.type = 'button';
            var icon = document.createElement('i');
            icon.classList.add('fas');
            if (prev) {
                icon.classList.add('tnt-chevron-left');
            } else {
                icon.classList.add('tnt-chevron-right');
            }
            if (prev) {
                btn.appendChild(icon);
                btn.append(' Previous');
            } else {
                btn.append('Next ');
                btn.appendChild(icon);
            }
            div.appendChild(btn);
            return df.appendChild(div);
        },
        stageSize: function(el) {
            var stage = el.querySelector('.tnt-paginated-article-stage'),
            pages = el.querySelectorAll('.tnt-paginated-article-page');
            
            for (var i = 0; i < pages.length; i++) {
                pages[i].style.width = el.offsetWidth + 'px'; 
            }
            
            stage.style.width = el.offsetWidth * pages.length + 'px';
            stage.style.transition = 'all 0.25s ease 0s';
        },
        setTranslate: function(el, pos) {
            var stage = el.querySelector('.tnt-paginated-article-stage'),
            translatePos,
            stageWidth = el.offsetWidth;
        
            if (pos == 1) {
                translatePos = 0;
            } else {
                translatePos = (pos - 1) * el.offsetWidth;
            }
        
            stage.style.transform = "translate3d(" + -translatePos + "px, 0, 0)";
        },
        returnToTop: function(el, callback) {
            document.querySelector('.asset-content').scrollIntoView({behavior: "smooth"});
            if (callback) 
                setTimeout(function () {
                    callback();
                }, 500);
            },
        autoHeight: function(el) {
            var activePage = el.querySelector('.active'),
            activePageHeight = activePage.offsetHeight;
            el.querySelector('.tnt-paginated-article-outer-stage').style.height = activePageHeight + 'px';
        },
        slideCounter: function(el) {
            var counter = el.querySelectorAll('.tnt-paginated-article-controls-counter');
        
            for (var i = 0; i < counter.length; ++i) {
                var counterIndex = counter[i].querySelector('.tnt-paginated-index');
                counterIndex.innerHTML = this.currentPosition(el);
            }
        }
    };
})(document, __tnt);